export default "__VITE_PUBLIC_ASSET__e0edff6a__"